module.exports = __webpack_public_path__ + "img/app-window.b0e3075f.svg";